function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5516 19.9999H0.448295C0.200737 19.9999 0 19.7642 0 19.4735V0.526573C0 0.235924 0.200737 0.000244141 0.448295 0.000244141H25.5516C25.7992 0.000244141 25.9999 0.235924 25.9999 0.526573V19.4735C25.9999 19.7642 25.7991 19.9999 25.5516 19.9999Z",
  fill: "#41479B"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9999 0.526573C25.9999 0.235924 25.7991 0.000244141 25.5516 0.000244141H23.546L15.2413 6.3884V0.000244141H10.7585V6.3884L2.45384 0.000244141H0.448295C0.200737 0.000244141 0 0.235924 0 0.526573V1.88777L7.12503 7.3685H0V12.6316H7.12503L0 18.1123V19.4735C0 19.7642 0.200737 19.9999 0.448295 19.9999H2.45389L10.7586 13.6117V19.9999H15.2414V13.6117L23.5461 19.9999H25.5517C25.7992 19.9999 26 19.7642 26 19.4735V18.1123L18.8749 12.6316H25.9999V7.36856H18.8748L25.9999 1.88777V0.526573Z",
  fill: "#F5F5F5"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.9999 8.42092H14.3448V0H11.6551V8.42092H0V11.5787H11.6551V19.9996H14.3448V11.5787H25.9999V8.42092Z",
  fill: "#FF4B55"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M9.08716 12.6313L0.0126953 19.5471C0.0444335 19.8013 0.222929 19.9997 0.448244 19.9997H1.06569L10.7339 12.6314H9.08716V12.6313V12.6313Z",
  fill: "#FF4B55"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M17.59 12.6313H15.9432L25.5974 19.9888C25.8224 19.9606 26 19.7449 26 19.4733V19.0405L17.59 12.6313Z",
  fill: "#FF4B55"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.10751L8.2153 7.36848H9.86203L0.261167 0.0515137C0.107808 0.135161 0 0.314916 0 0.526509V1.10751Z",
  fill: "#FF4B55"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8881 7.36825L25.9843 0.435765C25.9465 0.19001 25.7719 0 25.5516 0H24.9094L15.2413 7.36825H16.8881Z",
  fill: "#FF4B55"
});

var SvgEng = function SvgEng(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEng, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/eng.f75cd023.svg";
export { ForwardRef as ReactComponent };